import type { AddOnId, Gender } from "./types"
import type { PriceMap } from "@/lib/pricing"
import { addOnPriceKey } from "./product-mapping"
import { addOnBookingProductId } from "./product-info-map"

/**
 * Resolve quiz add-ons to booking product UUIDs, preferring LIVE ids from the
 * get-products catalog (PriceData.productIds, keyed by price-map key) and
 * falling back to the hardcoded seed map in product-info-map.ts. The live map
 * only contains resolvable, non-archived products, so preferring it means we
 * never emit a stale UUID. trend_overlay has no sku and is dropped. Order preserved.
 */
export function resolveAddOnIds(
  addOns: readonly AddOnId[],
  gender: Gender | undefined,
  liveProductIds: PriceMap
): string[] {
  return addOns
    .map((id) => {
      const key = addOnPriceKey(id, gender)
      const live = key ? liveProductIds[key] : undefined
      return live ?? addOnBookingProductId(id, gender)
    })
    .filter((uuid): uuid is string => !!uuid)
}
